export default __webpack_public_path__ + "static/media/linkedin.d8b7a68e.svg";